var LoggerInstance = require("js-logger").get("Carousel");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false,
	carouselCurrentPages: {}, // { carouselId: pagNum } initially empty
	categoryId: null,
	layoutId: null,
	touchstartX: 0,
	touchendX: 0,
	url: null
};

var CarouselStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.CAROUSEL_INITIALIZE:
					state.isDesignMode = action.isDesignMode;
					state.categoryId = action.categoryId;
					state.layoutId = action.layoutId;
					state.url = action.url;
					return true; // Don't emit change

				case Constants.CAROUSEL_NEXT_PAGE:
					var carouselId = action.carouselId;
					var currentPage = state.carouselCurrentPages[carouselId];
					if (!currentPage) {
						// Assume we haven't had any requests for this component yet.
						currentPage = 1;
					}

					state.carouselCurrentPages[carouselId] = currentPage + 1;
					return true; // Don't emit change

				case Constants.CAROUSEL_PREVIOUS_PAGE:
					var carouselId = action.carouselId;
					var currentPage = state.carouselCurrentPages[carouselId];

					if (currentPage > 1)
					{
						state.carouselCurrentPages[carouselId] = currentPage - 1;
					}
					return true; // Don't emit change

				case Constants.CAROUSEL_TOUCH_START:
					state.touchstartX = action.touchstartX;
					return true;

				case Constants.CAROUSEL_TOUCH_END:
					state.touchendX = action.touchendX;
					return true;

				default:
					// no op
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

module.exports = new CarouselStore(Dispatcher);
